import { LoadImage } from './image.actions';

export const ImageLoadingActions = [LoadImage];
